import PageTitle from "../../components/PageTitle";
import {useEffect, useState} from "react";
import api from "../../hooks/useApi";
import {useNavigate} from "react-router-dom";

export default function BookingIndexPage() {

    //ВРЕМЕННО ДЛЯ ТЕСТОВ
    const navigate = useNavigate();

    function getCookie(name) {
        const matches = document.cookie.match(new RegExp(
            "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
        ));
        return matches ? decodeURIComponent(matches[1]) : undefined;
    }

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const accessToken = getCookie("access");

                if (!accessToken) {
                    navigate("/login");
                    return;
                }

                const response = await api.get("/api/user/profile/", {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });

                const user = response.data;


            } catch (error) {
                if (error.response?.status === 401) {
                    navigate("/login");
                } else {
                    console.error("Ошибка загрузки пользователя:", error);
                }
            }
        };

        fetchUserData();
    }, [navigate]);
    //ВРЕМЕННО ДЛЯ ТЕСТОВ

    return (
        <>
            <PageTitle title="Пошук бронювання"/>
            Для початку пошуку, заповніть поля у фільтрі
        </>
    );
}
